import "core-js/modules/es.string.match";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.split";
/**
 * Helper: Parse Date
 * -----------------------------------------------------------------------------
 * Formats mto european date format to required default format.
 *
 * @namespace parseDate
 */

/**
 * Required date format.
 */

const dateFormat = 'dd/mm/yyyy';
const defaultFormat = 'mm/dd/yyyy';
/**
 * Convert end date from custom to standard format.
 * @param {String} input - MTO product end date.
 */

export default function parseDate(input) {
  const parts = input.match(/(\d+)/g);
  const dateFormatArr = dateFormat.match(/(\w+)/g);
  const defaultDateFormatArr = defaultFormat.match(/(\w+)/g);
  const dateExtract = parts.slice(0, dateFormatArr.length);
  const formattedDate = dateExtract.map((item, index) => {
    const itemIndex = defaultDateFormatArr.indexOf(dateFormatArr[index]);
    return dateExtract[itemIndex];
  }).join('/');
  return "".concat(formattedDate, " ").concat(input.split(' ')[1]);
}